import React from 'react'

import { Document } from '@contentful/rich-text-types'
import Button from '../../../../baby-design/components/Button/Button'
import css from './WhyTrustUsSection.styles.scss'
import { RightArrow } from '../../../../baby-design/icons'
import RichTextBody from '../../RichTextBody/RichTextBody'

interface PostEmbedWhyTrustUsSectionFields {
  howWePicked?: Document
  methodologyLinkText?: string
}

export interface WhyTrustUsSectionProps {
  fields: PostEmbedWhyTrustUsSectionFields
}

const WhyTrustUsSection: React.FC<WhyTrustUsSectionProps> = ({
  fields,
}: WhyTrustUsSectionProps) => {
  const { howWePicked, methodologyLinkText } = fields

  return (
    <section className={css.WhyTrustUsSection}>
      <h2 className={css.WhyTrustUsSection__header}>Why Trust Babylist?</h2>
      <p>
        Babylist is the expert in baby; we know baby gear inside and out. We
        talk with parents face-to-face in our showroom and on our user panels
        and hear from thousands annually via our Best Baby Products online
        survey. We know what items millions of expecting parents are adding to
        their baby registries.
      </p>
      {howWePicked && (
        <div>
          <RichTextBody richTextBody={howWePicked as Document} />
        </div>
      )}
      {methodologyLinkText && (
        <Button
          href="#editorial-methodology"
          icon={{ side: 'right', icon: <RightArrow /> }}
          size="md"
          variant="primary"
        >
          {methodologyLinkText}
        </Button>
      )}
    </section>
  )
}

export default WhyTrustUsSection
